'use client';
import { useState } from 'react';

import {
  IconMonitor,
  IconPageLandscape,
  IconSun,
  IconUsbDongle,
} from '@veneer/core';
import { useTranslation } from 'react-i18next';

import { NamespacesI18n } from '@storefront/i18n';

import styles from './index.module.scss';
import { ModalAccessories } from '../index';

const IconMap = {
  featurePanel: IconMonitor,
  featureRGB: IconPageLandscape,
  featureView: IconMonitor,
  featureVideo: IconMonitor,
  featureBrightness: IconSun,
  featureConnection: IconUsbDongle,
  featureChromebook: IconUsbDongle,
  featureCable: IconUsbDongle,
};

interface Features {
  [key: string]: {
    label: string;
    text: string;
  };
}

interface FeatureGroup {
  type: string;
  list: Features[];
}

interface ModalMonitorProps {
  model?: string;
}

export const ModalMonitor = () => {
  const i18nPrefix = 'pc.modalMonitor';
  const { t } = useTranslation(NamespacesI18n.PDP_CONFIG, {
    keyPrefix: i18nPrefix,
  });
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => {
    setShowModal(false);
  };

  const featuresColor: FeatureGroup = {
    type: 'featuresColor',
    list: t('featuresColorList', {
      returnObjects: true,
    }),
  };
  const featuresPorts: FeatureGroup = {
    type: 'featuresPorts',
    list: t('featuresPortsList', {
      returnObjects: true,
    }),
  };

  const formatedFeature = (features: { type: string; list: Features[] }) => (
    <div>
      <p className={`subtitle-regular ${styles['title']}`}>
        {t(`${features.type}`)}
      </p>
      <ul className={styles['list']}>
        {features.list.map((item) => {
          const [icon, feature] = Object.entries(item)[0];
          const Icon = IconMap[icon as keyof typeof IconMap];
          return (
            <li className={`${styles.feature} subtitle-regular`} key={icon}>
              <Icon size={24} />
              <div className={styles.text}>
                <p className="body-regular">{feature.label}</p>
                <p className="caption-small">{feature.text}</p>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );

  return (
    <>
      <ModalAccessories
        title="modal-monitor"
        show={showModal}
        className={styles['modal-container']}
        i18nPrefix={i18nPrefix}
        styles={styles}
        featuresImg={{
          src: 'modal_monitor_1.png',
          alt: 'monitor',
          width: 546,
          height: 391,
          quality: 100,
          className: styles['vertical-image'],
        }}
        featuresImgSecondary={{
          src: 'modal_monitor_2.png',
          alt: 'monitor',
          width: 1659,
          height: 1246,
          quality: 100,
          className: styles['vertical-image'],
        }}
        features={formatedFeature(featuresColor)}
        featuresSecondary={formatedFeature(featuresPorts)}
        onClose={handleClose}
      />
      <input
        id="open-modal-monitor"
        data-testid="modal-monitor"
        tabIndex={0}
        className={styles['modal-button']}
        aria-label="modal monitor"
        type="button"
        value={t('link')}
        onClick={async () => {
          setShowModal(true);
        }}
      />
    </>
  );
};
